import { edgesManager } from '@/threejs/managers/edgesManager';
import { tryOnBeforeUnmount, tryOnMounted } from '@vueuse/core';
import { ref } from 'vue';

import { useCruxModuleStore } from '@/stores/api/cruxmodules';

export const useHistoryTracker = () => {
  const cruxModuleStore = useCruxModuleStore();
  const historyEntries = ref([]);
  const currentPosition = ref(-2); // Track current position in history
  const isRedoing = ref(false); // Flag to prevent watcher during redo
  const isUndoing = ref(false); // Flag to prevent watcher during undo

  // Debounce function for timeline updates
  let timelineUpdateTimeout = null;

  const undo = async () => {
    if (!canUndo()) return;
    isUndoing.value = true;
    cruxModuleStore.undo();

    isUndoing.value = false;
    edgesManager.refreshFlb();

    // save the cruxModuleStores
    cruxModuleStore.save();
  };

  const redo = async () => {
    if (!canRedo()) return;

    isRedoing.value = true;

    cruxModuleStore.redo();
    isRedoing.value = false;
    edgesManager.refreshFlb();
  };

  const canUndo = () => {
    return cruxModuleStore.history.length > 2;
  };

  const canRedo = () => {
    return cruxModuleStore.history.length > 1;
  };

  const handleKeyDown = (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'z' && !event.shiftKey) {
      event.preventDefault();
      undo();
    }

    if (
      ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'z' && event.shiftKey) ||
      ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'y')
    ) {
      event.preventDefault();
      redo();
    }
  };

  // Add event listener when component is mounted
  tryOnMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
  });

  tryOnBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown);
    // Clean up the debounce timeout
    if (timelineUpdateTimeout) {
      clearTimeout(timelineUpdateTimeout);
    }
  });

  return {
    historyEntries,
    currentPosition,
    undo,
    redo,
    canUndo,
    canRedo,
  };
};
